import React, { useEffect, useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import { ChevronArrowRightIcon } from '../../assets/icons/ChevronArrowRightIcon'
import { CloseIcon } from '../../assets/icons/CloseIcon'
import { SearchIcon } from '../../assets/icons/SearchIcon'
import { SicrediLogo } from '../../assets/icons/SicrediLogo'
import { SICREDI_LOGO_VERDE } from '../../libraries/SicrediLogoThemes'
import { getMergedClassNames } from '../../utils/HTMLutils'
import { getStringWithoutSpecialChar } from '../../utils/MaskUtils'
import IconButton from '../iconButton/IconButton'
import Input from '../input/Input'
import MenuItem, { MenuItemProps } from './components/menuItem/MenuItem'
import './Menu.scss'
const rootClassName = 'component-menu'
var timeout: any

interface MenuProps {
  className?: string
  buscar?: boolean
  shortOnMD?: boolean
  openOnClick?: boolean
  hamburgerMenu?: boolean
  opened?: boolean
  setOpened?: (event?: any) => void
  logo?: React.ReactNode
  items?: MenuItemProps[]
}

export default function Menu(props: MenuProps) {
  const [opened, setOpened] = useState(false)
  const [buscarValue, setBuscarValue] = useState('')

  useEffect(() => {
    const closeOnEsc = (evt: any) => {
      if (evt.key === 'Escape') {
        setOpened(false)
        if (typeof props.setOpened === 'function') props.setOpened(false)
      }
    }
    if (opened || props.opened) {
      document.addEventListener('keydown', closeOnEsc)
    }
    return () => {
      document.removeEventListener('keydown', closeOnEsc)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened, props.opened])

  useEffect(() => {
    const onResizeHandle = (evt: any) => {
      if (evt.target.innerWidth > 991.98) {
        setOpened(false)
        if (typeof props.setOpened === 'function') props.setOpened(false)
      }
    }
    if (props.openOnClick) {
      window.addEventListener('resize', onResizeHandle)
    }
    return () => {
      window.removeEventListener('resize', onResizeHandle)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.openOnClick])

  const getProps = () => {
    const openedOrNot = (condition: any) => {
      if (condition) return `${rootClassName}-opened`
      return ''
    }
    const p: any = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        'scroll-white',
        props.className,
        props.shortOnMD ? `${rootClassName}-short-on-md` : '',
        props.openOnClick ? `${rootClassName}-open-on-click` : '',
        props.hamburgerMenu ? `${rootClassName}-hamburger-menu` : '',
        (props.openOnClick || props.hamburgerMenu) &&
          (props.opened !== undefined
            ? openedOrNot(props.opened)
            : openedOrNot(opened))
      ])
    }
    delete p.openOnClick
    delete p.shortOnMD
    delete p.items
    delete p.icon
    delete p.opened
    delete p.setOpened
    delete p.hamburgerMenu
    delete p.logo
    delete p.buscar
    return p
  }

  useEffect(() => {
    if (timeout) clearTimeout(timeout)
    if (!opened && !props.opened) {
      timeout = setTimeout(() => {
        setBuscarValue('')
      }, 300)
    }
  }, [opened, props.opened])

  const getItems = () => {
    const it = [...(props.items || [])].map((it) => {
      return { ...it }
    })
    if (!it) return []
    if (props.buscar && buscarValue) {
      return it.filter((item) => {
        if (
          getStringWithoutSpecialChar(item.label)
            .trim()
            .toLowerCase()
            .match(
              getStringWithoutSpecialChar(buscarValue).trim().toLowerCase()
            )
        ) {
          return true
        }
        if (
          item.subList &&
          Array.from(item.subList).some((subItem) =>
            getStringWithoutSpecialChar(subItem.label)
              .trim()
              .toLowerCase()
              .match(
                getStringWithoutSpecialChar(buscarValue).trim().toLowerCase()
              )
          )
        ) {
          item.subList = Array.from(item.subList).filter((subItem) =>
            getStringWithoutSpecialChar(subItem.label)
              .trim()
              .toLowerCase()
              .match(
                getStringWithoutSpecialChar(buscarValue).trim().toLowerCase()
              )
          )
          return true
        }
        return false
      })
    }
    return it
  }

  return (
    <React.Fragment>
      <div {...getProps()}>
        {props.hamburgerMenu && (
          <IconButton
            className={`${rootClassName}-close-button`}
            icon={<CloseIcon />}
            onClick={() => {
              setOpened(false)
              if (typeof props.setOpened === 'function') props.setOpened(false)
            }}
          />
        )}
        <div className={`${rootClassName}-logo`}>{props.logo}</div>
        {props.buscar ? (
          <div className={`${rootClassName}-buscar`}>
            <Input
              id='buscar-menu'
              placeholder='Buscar'
              value={buscarValue}
              onChange={(evt) => {
                setBuscarValue(evt!?.target.value)
              }}
              rightObject={<IconButton icon={<SearchIcon />} />}
            />
          </div>
        ) : undefined}
        <div className={`${rootClassName}-items`}>
          {getItems()
            ? getItems().map((it, index) => {
                return (
                  <div className={`${rootClassName}-it`} key={index}>
                    <MenuItem
                      {...it}
                      buscar={props.buscar}
                      buscarValue={buscarValue}
                    />
                  </div>
                )
              })
            : undefined}
        </div>
      </div>
      <React.Fragment>
        {props.openOnClick && (
          <button
            className={`${rootClassName}-toggle ${
              opened ? `${rootClassName}-opened` : ''
            }`}
            onClick={() => {
              setOpened(!opened)
              if (typeof props.setOpened === 'function') props.setOpened(false)
            }}
          >
            <ChevronArrowRightIcon />
          </button>
        )}
      </React.Fragment>
      <React.Fragment>
        {(props.openOnClick || props.hamburgerMenu) && (
          <CSSTransition
            timeout={300}
            classNames={`${rootClassName}-background`}
            in={
              (props.openOnClick || props.hamburgerMenu) &&
              (props.opened !== undefined ? props.opened : opened)
            }
            mountOnEnter
            unmountOnExit
          >
            <div
              className={`${rootClassName}-background`}
              onClick={() => {
                setOpened(false)
                if (typeof props.setOpened === 'function')
                  props.setOpened(false)
              }}
            />
          </CSSTransition>
        )}
      </React.Fragment>
    </React.Fragment>
  )
}

Menu.defaultProps = {
  openOnClick: false,
  shortOnMD: false,
  hamburgerMenu: false,
  opened: undefined,
  logo: <SicrediLogo theme={SICREDI_LOGO_VERDE} height='35px' />,
  items: []
}
